import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from '../../shared/components/Nav/Nav';

const NAV_ITEMS = [
	{
		id: 'documentation',
		label: 'Documentation',
		to: '/support/documentation',
	},
	{
		id: 'validation',
		label: 'Data validation',
		to: '/support/validation',
	},
];

const SupportNav = () => {
	const { pathname } = useLocation();

	const navItems = NAV_ITEMS;
	// global mode

	const match = useMemo(
		() => navItems.find((item) => pathname.startsWith(item.to)),
		[pathname]
	);

	return <Nav active={match?.id} items={navItems} />;
};

export default SupportNav;
